module.exports = __webpack_public_path__ + "img/kakeibo-budget-planner_B09K26HQPT.5ca8b91c.jpg";